import { NgModule } from '@angular/core';

import { ProtectedRoutingModule } from './protected-routing.module';
import { SharedModule } from '../shared/shared.module';
import { EmployeesModule } from './employees/employee.module';
import { BeneficiairesModule } from './beneficiaires/beneficiaires.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { MapModule } from './map/map.module';
import { MissionPlaceModule } from './mission-place/mission-place.module';
import { SpecialitesModule } from './specialites/specialites.module';
import { ProfileModule } from './profile/profile.module';
import { AreaModule } from './area/area.module';
import { MessagerieModule } from './messagerie/messagerie.module';
import { UsersModule } from './users/users.module';
import { RolesModule } from './role/role.module';
import { TauxReconnaissanceModule } from './tauxReconnaissance/tauxReconnaissance.module';
import { NiveauEtudeModule } from './niveauEtude/niveauEtude.module';
import { NiveauQualificationModule } from './niveauQualification/niveauQualification.module';
import { TypeStructureModule } from './typeStructure/typeStructure.module';
import { ModaliteReunionModule } from './modaliteReunion/modaliteReunion.module';
import { ObjectifProModule } from './objectifPro/objectifPro.module';
import { OrigineDemandeModule } from './origineDemande/origineDemande.module';
import { AmenagementModule } from './amenagement/amenagement.module';
import { NotificationEmailModule } from './notificationEmail/notificationEmail.module';
import { ExpertiseModule } from './expertise/expertise.module';
import { SituationModule } from './situation/situation.module';
import { PrestationsModule } from './prestation/prestation.module';
import { TypeEntretienModule } from './typeEntretien/typeEntretien.module';
import { TacheModule } from './tache/tache.module';
import { SystemeModule } from './systeme/systeme.module';
import { InstitutionsModule } from './systeme/institution/institution.module';
import { DepartementModule } from './departement/departement.module';
import { RegionModule } from './region/region.module';
import { ServiceModule } from './service/service.module';
import { InfosasModule } from './infosas/prestation.module';
import { CanalCommunicationModule } from './canalCommunication/canalCommuncation.module';
import { TypeHandicapModule } from './typeHandicap/typeHandicap.module';
import { EligibiliteBeneficiaireModule } from './eligibiliteBeneficiaire/eligibiliteBeneficiaire.module';
import { StatutProfessionnelModule } from './statutProfessionnel/statutProfessionnel.module';
import { PrescripteursModule } from './prescripteur/prescripteur.module';
import { TypeDocumentModule } from './typeDocument/typeDocument.module';
import { BonCommandeModule } from './bonCommande/bonCommande.module';
import { SituationFamilialeModule } from './situationFamiliale/situationFamiliale.module';
import { TypeFormationModule } from './typeFormation/typeFormation.module';
import { TypeEntrepriseModule } from './typeEntreprise/typeEntreprise.module';
import { EmployeursModule } from './employeur/employeur.module';
@NgModule({
	declarations: [],
	imports: [
		SharedModule,
		ProtectedRoutingModule,
		EmployeesModule,
		EmployeursModule,
		BeneficiairesModule,
		PrescripteursModule,
		DashboardModule,
		MapModule,
		MissionPlaceModule,
		SpecialitesModule,
		ProfileModule,
		AreaModule,
		MessagerieModule,
		UsersModule,
		RolesModule,
		TauxReconnaissanceModule,
		NiveauEtudeModule,
		NiveauQualificationModule,
		TypeStructureModule,
		TypeEntrepriseModule,
		TypeEntretienModule,
		TypeFormationModule,
		ModaliteReunionModule,
		ObjectifProModule,
		OrigineDemandeModule,
		AmenagementModule,
		SituationFamilialeModule,
		StatutProfessionnelModule,
		EligibiliteBeneficiaireModule,
		CanalCommunicationModule,
		DepartementModule,
		RegionModule,
		ServiceModule,
		NotificationEmailModule,
		ExpertiseModule,
		TypeHandicapModule,
		SituationModule,
		PrestationsModule,
		InfosasModule,
		TacheModule,
		InstitutionsModule,
		TypeDocumentModule,
		BonCommandeModule
	],
	exports: []
})
export class ProtectedModule {}
